import { Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { APP_LANGUAGE } from '../../localized-urls'
import DateFormat from '../helpers/DateFormat'
import { FormattedMessage } from 'react-intl'
import { generateGuestsText } from '../forms/GuestPicker'

function BackSectionDeparture({ date, guestsInRoom }) {
  if(!date || !date.dateFrom || !date.dateTo) {
    return <FormattedMessage id='any_date' defaultMessage='any date' />
  }
  const departureDate =
    date.dateFrom.substr(0, 4) === date.dateTo.substr(0, 4)
      ? moment(date.dateFrom).format('DD')
      : moment(date.dateFrom).locale(APP_LANGUAGE).format('DD MMM YYYY')
  return (
    <Fragment>
      {departureDate} - <DateFormat date={date.dateTo} format='DD MMM YYYY' />
      &nbsp;
      <FormattedMessage
        id='night_qty'
        values={{ qty: date.duration }}
        defaultMessage='{qty, plural, one {# night} other {# nights}}'
      />
      {guestsInRoom && (
        <Fragment>, {generateGuestsText(guestsInRoom)}</Fragment>
      )}
    </Fragment>
  )
}

export default connect((state) => ({
  date: state.departureDate,
  guestsInRoom: state.guestsInRoom,
}))(BackSectionDeparture)
